<i18n lang="json">
{
  "en": {
    "title": "Presented by"
  },
  "fr": {
    "title": "Présenté par"
  }
}
</i18n>

<template>
  <div class="flex gap-4 items-center">
    <div v-if="image" class="size-16 rounded-[50%] overflow-hidden bg-primary-25 justify-center">
      <img :src="image" class="size-full aspect-1" />
    </div>
    <div class="items-center">
      <h2 class="typography-body-1 text-primary-350">{{ t('title') }}</h2>
      <div class="typography-subtitle-1 mb-3">{{ name }}</div>
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  name: string
  image: string
}>()

const { t } = useI18n()
</script>
